import Timeframe from './Timeframe';

export default Timeframe;
